import React, {useState} from "react";
import {errors, ethers} from "ethers";
import ButtonPrimary from "components/Button/ButtonPrimary";
import {auth} from "../../configs/firebase-config";

declare let window: any;
// https://docs.metamask.io/guide/ethereum-provider.html#using-the-provider
const DashboardConnectWallet = () => {
  const username = auth.currentUser?.displayName;
  const [errorMessage, setErrorMessage] = useState<string>();
  const [defaultAccount, setDefaultAccount] = useState(null);
  const [userBalance, setUserBalance] = useState<any>();
  const [connButtonText, setConnButtonText] = useState("Connect Wallet");

  // update account, will cause component re-render
  const accountChangedHandler = (newAccount: any) => {
    setDefaultAccount(newAccount);
    getAccountBalance(newAccount.toString());
  }

  const getAccountBalance = (account: any) => {
    window.ethereum.request({method: "eth_getBalance", params: [account, "latest"]}).then((balance: any) => {
      setUserBalance(ethers.utils.formatEther(balance));
    }).catch((error: any) => {
      setErrorMessage(error.message);
    });
  };

  const chainChangedHandler = () => {
    window.location.reload();
  }

  const connectWalletHandler = () => {
    if (window.ethereum && window.ethereum.isMetaMask) {
      window.ethereum.request({ method: "eth_requestAccounts"}).then((result: any) => {
        accountChangedHandler(result[0]);
        setConnButtonText("Wallet Connected");
        getAccountBalance(result[0]);
        setErrorMessage("");
        window.ethereum.on("accountsChanged", accountChangedHandler);
        window.ethereum.on("chainChanged", chainChangedHandler);
      }).catch((error: any) => {
        setErrorMessage(error.message);
      });
    } else {
      setErrorMessage("Please install MetaMask browser extension to interact");
    }
  }




  return (
    <div className="rounded-xl min-h-full text-sm border border-neutral-100 dark:border-neutral-800 p-6 md:text-base">
      {defaultAccount ?
        <>
          <div>
            <h3>Address: {defaultAccount}</h3>
          </div>
          <div>
            <h3>Balance: {userBalance}</h3>
          </div>
          {errorMessage}
        </> :
        <>
          <span className="block text-lg mb-3">
            <strong>Connect your MetaMask wallet today, {username}</strong>
          </span>
          <span className="block text-lg mb-3">
            Why Should I Connect My Wallet?
          </span>
          Every day, we work tirelessly to implement new features to make The CryptoVerse community more powerful. By connecting your wallet, you will be able to send and receive funds when the feature has been implemented. You will also be able to showcase your Non Fungible Token collection on your profile for others to see. We hope to have this feature implemented by Mid 2022. For now, you can connect your wallet by clicking the button below.
        </>
      }
      <div className=" md:border-neutral-100 dark:border-neutral-800 md:p-6">
        <div className="grid md:grid-cols-2 gap-6">
          <ButtonPrimary className="md:col-span-2" onClick={connectWalletHandler}>{connButtonText ? connButtonText : "Connect Wallet"}</ButtonPrimary>
        </div>
      </div>
      {errorMessage}
    </div>
  );
};

export default DashboardConnectWallet;

//   return (
//     <div className="walletCard" style={{margin: "1rem" }}>
//       <h4> {"Connection to MetaMask using window.ethereum methods"} </h4>
//       <button onClick={connectWalletHandler}>{connButtonText}</button>
//       <div className="accountDisplay">
//         <h3>Address: {defaultAccount}</h3>
//       </div>
//       <div className="balanceDisplay">
//         <h3>Balance: {userBalance}</h3>
//       </div>
//       {errorMessage}
//     </div>
//   );
// }

